<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{ [this.id ? 'MODIFICA' : 'NUOVO','LEAD'].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <form v-on:submit.prevent="" data-vv-scope="lead">
          <vs-col class="md:w-7/12 w-full">
            <vs-col vs-type="flex" vs-justify="flex-start">
              <label class="text-sm mt-8 mr-6">Scegli il tipo:</label>
              <vs-radio v-model="radio_ca" vs-value="az" class="mt-8 mr-4">Azienda</vs-radio>
              <vs-radio v-model="radio_ca" vs-value="con" class="mt-8">Contatto</vs-radio>
            </vs-col>
            <vs-col class="mt-4" v-if="radio_ca == 'az'" :key="formkey">
              <label class="text-sm">Azienda</label>
              <v-select @input="fillLeads" name="azienda" placeholder="Scrivi l'azienda da cercare..." :options="aziende" @search="fetchAziende" v-model="azienda" v-validate="'required'" :filterable="false" :disabled="!this.canEdit"><span slot="no-options">Nessun risultato</span></v-select>
              <span class="text-danger text-sm" v-show="errors.has('lead.azienda')">{{ errors.first('lead.azienda') }}</span>
            </vs-col>
            <vs-col class="mt-4" v-if="radio_ca == 'con'" :key="formkey">
              <label class="text-sm">Contatto</label>
              <v-select @input="fillLeads" name="contatto" placeholder="Scrivi il contatto da cercare..." :options="contatti" @search="fetchContatti" v-model="contatto" v-validate="'required'" :filterable="false" :disabled="!this.canEdit"><span slot="no-options">Nessun risultato</span></v-select>
              <span class="text-danger text-sm" v-show="errors.has('lead.contatto')">{{ errors.first('lead.contatto') }}</span>
            </vs-col>
            <vs-col class="mt-2">
              <label class="vs-input--label">Fabbisogno cliente</label>
              <v-select name="nome" placeholder="Scegli il fabbisogno del cliente..." :options="fabbisogni" v-model="nome" v-validate="'required'" :disabled="!this.canEdit"><span slot="no-options">Nessun risultato</span></v-select>
              <span class="text-danger text-sm" v-show="errors.has('lead.nome')">{{ errors.first('lead.nome') }}</span>
            </vs-col>
            <vs-col class="mt-2">
              <label class="vs-input--label">Responsabile</label>
              <v-select name="responsabile" placeholder="Scrivi il responsabile da assegnare.." :options="responsabili" v-model="responsabile" v-validate="'required'" :filterable="true"><span slot="no-options">Nessun risultato</span></v-select>
              <span class="text-danger text-sm" v-show="errors.has('lead.responsabile')">{{ errors.first('lead.responsabile') }}</span>
            </vs-col>
          </vs-col>
          <vs-col class="md:w-5/12 w-full">
            <vs-col vs-type="flex" vs-justify="flex-start">
              <label class="text-sm mt-8 mr-6">Reputazione</label>
              <star-rating :rounded-corners="true" @rating-selected ="setRating" :rating="reputazione" name="rating" :max-rating="3" :show-rating="false"></star-rating>
            </vs-col>
            <vs-col class="mt-1">
              <label class="text-sm">Priorità</label>
              <v-select name="priorita" placeholder="Scegli il livello di priorità..." :options="priorita_list" v-model="priorita" v-validate="'required'" :disabled="!this.canEdit"><span slot="no-options">Nessun risultato</span></v-select>
              <span class="text-danger text-sm" v-show="errors.has('lead.priorita')">{{ errors.first('lead.priorita') }}</span>
            </vs-col>
            <vs-col class="mt-4">
              <label class="text-sm">Data Scadenza</label>
              <vx-input-group class="mb-base">
                <datepicker typeable :disabled-dates="{to: new Date(data_inserimento)}" placeholder="Seleziona la data di scadenza..." :language="languages['it']" :format="datepicker_format" name="data_scadenza" v-validate="'required'" v-model="data_scadenza"></datepicker>
                <template v-if="data_scadenza" slot="append">
                  <div class="append-text btn-addon">
                    <vs-button @click="clearDateScad($event)" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                  </div>
                </template>
                <span class="text-danger text-sm" v-show="errors.has('lead.data_scadenza')">{{ errors.first('lead.data_scadenza') }}</span>
              </vx-input-group>
            </vs-col>
          </vs-col>
          <vs-col>
            <vs-col class="w-full mt-2">
              <label class="text-sm">Dettagli lead</label>
              <vs-input v-model="descrizione" placeholder="Inserisci i dettagli del lead" class="w-full" name="descrizione" v-validate="'required'" :disabled="!this.canEdit" />
              <span class="text-danger text-sm"  v-show="errors.has('lead.descrizione')">{{ errors.first('lead.descrizione') }}</span>
            </vs-col>
          </vs-col>
          <vs-col class="mt-6">
            <div class="flex items-end px-3 mt-4">
              <feather-icon svgClasses="w-6 h-6" icon="TargetIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Opportunità</span>
            </div>
            <vs-divider />
          </vs-col>
          <vs-col>
            <vs-col class="md:w-1/2 w-full">
              <label class="vs-input--label">Servizi</label>
              <multiselect  v-model="servizi"
                            :options="servizio_list"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            selectLabel="Invio per selezionare"
                            deselectLabel="Invio per de-selezionare"
                            selectedLabel="Selezionato"
                            noOptions="Lista vuota"
                            placeholder="Scegli i servizi interessati.."
                            label="label"
                            track-by="id"
                            :preselect-first="true">
                <template slot="selection"
                          slot-scope="{ values, search, isOpen }">
                </template>
                <template slot="noOptions">Lista vuota</template>
              </multiselect>
            </vs-col>
            <vs-col class="md:w-1/2 w-full">
              <vs-input v-currency="{}" class="w-full mt-1" placeholder="Inserisci il budget che il cliente può spendere..." label="Budget" v-model="budget" name="budget" />
              <span class="text-danger text-sm"  v-show="errors.has('lead.budget')">{{ errors.first('lead.budget') }}</span>
            </vs-col>
          </vs-col>

          <vs-col class="w-full mt-4">
            <div class="flex items-end px-3 mt-4">
              <feather-icon svgClasses="w-6 h-6" icon="CoffeeIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Coinvolgimento</span>
            </div>
            <vs-divider />
          </vs-col>
          <vs-col class="mb-6">
          <vs-col class="md:w-1/2 w-full">
            <label class="vs-input--label">Canale</label>
            <v-select name="canale" placeholder="Scegli il canale da dove è arrivato il contatto..." :options="canale_list" v-model="canale"><span slot="no-options">Nessun risultato</span></v-select>
            <span class="text-danger text-sm"  v-show="errors.has('lead.origine')">{{ errors.first('lead.origine') }}</span>
          </vs-col>
          <vs-col class="md:w-1/2 w-full">
            <label class="vs-input--label">Origine</label>
            <vs-input v-model="origine" class="w-full" name="origine" placeholder="Inserisci il nome del canale, come sito web, nome magazie, ecc....." v-validate="'max:100'" />
            <span class="text-danger text-sm"  v-show="errors.has('lead.origine')">{{ errors.first('lead.origine') }}</span>
          </vs-col>
        </vs-col>
          <vs-row v-if="this.leads_cliente.length">
          <vs-col class="mt-6">
            <div class="flex items-end px-3 mt-4">
              <feather-icon svgClasses="w-6 h-6" icon="ActivityIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Leads attivi del Cliente</span>
            </div>
          </vs-col>
          <vs-divider />
          <vs-col class="vx-col w-full white_back">
            <vs-table :pagination="this.leads_cliente.length > 4" max-items="4" :data="leads_cliente" >
              <template slot="thead">
                  <vs-th :key="i" v-for="(e, i) in ['Fabbisogno Cliente', 'Tipo', 'Stato', 'Responsabile', 'Date']">{{e}}</vs-th>
              </template>
              <template slot-scope="{data}">
                <colgroup ref="colgrouptable">
                  <col :key="0" :name="`col-0`" width="20%"/>
                  <col :key="1" :name="`col-1`" width="20%"/>
                  <col :key="2" :name="`col-2`" width="20%"/>
                  <col :key="3" :name="`col-3`" width="20%"/>
                  <col :key="4" :name="`col-4`" width="20%"/>
                </colgroup>
                <vs-tr class="cursor-arrow" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="tr.nome">
                    {{tr.nome}}
                  </vs-td>
                  <vs-td :data="[tr.azienda, tr.contatto]">
                    <vx-tooltip v-if="tr.azienda" text="Azienda" position="top">
                      <vs-button class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-grid"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-else-if="tr.contatto" text="Contatto" position="left">
                      <vs-button icon-pack="feather" icon="icon-phone-call" class="no-pointer-event inline-block p-1" type="flat" ></vs-button>
                    </vx-tooltip>
                  </vs-td>
                  <vs-td :data="tr.stato">
                    {{tr.stato.nome}}
                  </vs-td>
                  <vs-td :data="tr.responsabile">
                    {{[tr.responsabile.cognome,tr.responsabile.nome].join(' ')}}
                  </vs-td>
                  <vs-td :data="tr.data_inserimento">
                    {{formatDate(tr.data_inserimento)}}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-col>
        </vs-row>
      </form>
      <vs-row slot="footer" class="mb-3 mt-3">
        <vs-divider />
        <vs-col vs-type="flex" vs-justify="space-around" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button v-if="this.id" @click="eliminaLead" :disabled="!$acl.check('responsabile') && this.utente_id != this.responsabile.id" type="line" color="danger" icon-pack="feather" icon="icon-trash">Elimina</vs-button>
          <vs-button @click="salvaLead($event)" type="line" color="success" icon-pack="feather" icon="icon-save">Salva</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </vs-col>
</vs-row>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import axios from 'axios'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import Datepicker from '@sum.cumo/vue-datepicker';
import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'
import * as lang from 'vuejs-datepicker/src/locale';
import {StarRating} from 'vue-rate-it';

// For custom error message
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    nome: {
      required: 'Nome è un campo obbligatorio'
    },
    responsabile: {
      required: 'Responsabile è un campo obbligatorio',
    },
    priorita: {
      required: 'Priorità è un campo obbligatorio',
    },
    servizio: {
      required: 'Servizio è un campo obbligatorio',
    },
    data_scadenza: {
      required: 'Inserire una data di scadenza',
      after: 'La data di scadenza deve essere successiva a quella di inizio'
    },
    azienda: {
      required: 'Selezionare un\'azienda',
    },
    contatto: {
      required: 'Selezionare un conatto',
    },
    descrizione: {
      required: 'Descrizione è un campo obbligatorio',
    },
    opportunita: {
      max: 'Massimo 100 caratteri'
    },
    coinvolgimento: {
      max: 'Massimo 100 caratteri'
    },
    origine: {
      max: 'Massimo 100 caratteri'
    },
    budget: {
      numeric: 'Inserire un numero'
    },
    radio_ca: {
      required: `Selezionare un'opzione`
    }

  }
};

// register custom messages
Validator.localize('it', dict);

export default {
  data() {
    return {
      // board
      id: null,
      fabbisogni: ['Informazioni sui servizi',
                    'Informazioni Associative',
                    'Informazioni generali',
                    'Nuovo Preventivo',
                    'Modifica condizioni contrattuali',
                    'Problemi associativi',
                    'Problemi servizi',
                    'Apertura attività',
                    'Altro'],
      nome: "",
      descrizione: "",
      priorita: null,
      reputazione: 0,
      opportunita: "",
      budget: null,
      coinvolgimento: "",
      canale: null,
      origine: "",
      data_inserimento: "",
      data_scadenza: "",
      data_completamento: "",
      id_azienda: null,
      id_contatto: null,
      id_creatore: null,
      id_responsabile: null,

      utente_nome: "",
      utente_id: null,

      nome_creatore: "",
      creatore: null,

      aziende: [],
      azienda: null,

      servizio_list: [],
      servizi: [],

      contatti: [],
      contatto: null,

      responsabili: [],
      responsabile: null,

      radio_ca: 'az',

      priorita_list: ['Bassa', 'Media', 'Alta'].map(e => { return {label: e} }),
      canale_list: ['Portale Web', 'Newsletter', 'Radio', 'Tv', 'Passaparola', 'Giornali', 'Prima visita', 'Visita', 'Social', 'Altro'].map(e => { return {label: e} }),

      datepicker_format: "d.MM.yyyy",
      languages: lang,

      formkey: null,

      leads_cliente: []
    }
  },

  props: {
    selected: Object,
    id_stato: Number,
    id_az: Object,
    id_cont: Object,
  },
  components: {
    vSelect,
    Multiselect,
    Datepicker,
    StarRating,
  },
  mounted() {
    this.getUtenti()
    this.getServizi()
    this.formkey = Math.random()
    if(this.selected) {
      const selected = Object.assign({}, this.selected); // =====> così non rimane aperta sidebar
      // const selected = this.selected // ====> così rimane aperta sidebar ma non si chiude più
      delete selected.attivita_leads
      Object.keys(selected).forEach(e => this[e] = !selected[e] ? "" : selected[e])
      if(this.azienda && this.azienda.id) {
        this.azienda['label'] = `${this.azienda['ragione_sociale']} - ${this.azienda['codice_fiscale']}`
        this.radio_ca = 'az'
        this.leads_cliente = this.azienda['leads'].filter( l => l.id != this.id )
      }
      if(this.contatto && this.contatto.id) {
        this.contatto['label'] = `${this.contatto['nome']} ${this.contatto['cognome']}`
        this.radio_ca = 'con'
        this.leads_cliente = this.contatto.leads.filter( l => l.id != this.id )
      }
      // if(this.canale) {
      //   this.canale['label'] = `${this.canale}`
      // }
      if(this.creatore) {
        this.nome_creatore = this.creatore['nome']
      }
      if(this.responsabile) {
        this.responsabile['label'] = `${this.responsabile['cognome']} ${this.responsabile['nome']}`
      }
      this.reputazione = selected.reputazione
      if (this.budget) {
        this.budget = this.budget.toLocaleString('it-IT')
      }
    } else {
      this.nome_creatore = localStorage.utente_nome
      if (this.id_az && this.id_az.id) {
        this.azienda = {}
        this.azienda['label'] = this.id_az.label
        this.azienda['id'] = this.id_az.id
        this.radio_ca = 'az'
      }
      else if (this.id_cont && this.id_cont.id) {
        this.contatto = {}
        this.contatto['label'] = this.id_cont.label
        this.contatto['id'] = this.id_cont.id
        this.radio_ca = 'con'
      }
    }
    if (localStorage.utente_nome) {
      this.utente_nome = localStorage.utente_nome
    }
    if (localStorage.utente_id) {
      this.utente_id = localStorage.utente_id
    }
  },

  methods: {
    getServizi() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/trova_servizi_crm',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.servizio_list = response.data.map(e => {
          e['label'] = e['codice']
          return e
        })
        this.servizio_list.push({'label':'Assistenza','codice':'Assistenza'})
      }).catch(e => console.log(e))
    },
    buildSaveObject() {
      let obj = {
        nome: this.nome,
        descrizione: this.descrizione,
        priorita: this.priorita.label,
        data_scadenza: this.data_scadenza,

        id_stato: this.id_stato,

        reputazione: this.reputazione,
        coinvolgimento: this.coinvolgimento,
        canale: this.canale ? this.canale.label : '',
        origine: this.origine,
        opportunita: this.opportunita,
        budget: +this.budget,

        // servizi: this.servizi ? this.servizi.map( e => ),
        id_azienda: this.azienda ? this.azienda.id : null,
        id_contatto: this.contatto ? this.contatto.id : null,
        id_responsabile: this.responsabile ? this.responsabile.id : null
      }

      if(this.id) {
        obj['id'] = this.id
        if (this.data_completamento) obj['data_completamento'] = this.data_completamento
      }
      if(this.servizi.length > 0) {
        obj['servizi'] = this.servizi
      }
      if (this.budget) {
       obj['budget'] = this.$parseCurrency(this.budget)
      }
      // console.log('Salvando Lead.. ',obj);
      return obj
    },
    salvaLead(ev) {
      this.validateLead().then(() => {
        let action = this.id ? 'modifica' : 'crea'
        axios.post(process.env.VUE_APP_BACKEND_API+'/board/lead/' + action, this.buildSaveObject(), {
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true
        })
        .then(() => {
          this.$emit('lead-salvato')
          ev.stopPropagation()
        })
        .catch(e => console.log(e))
      })
    },
    validateLead() {
      console.log('VALIDATE LEAD');
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('lead').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },
    fetchAziende(q, loading) {
      if (q.trim().length < 3) {
        this.aziende = []
        this.contatti = []
        return
      }
      loading(true)

      axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/trova_live', { keyword: q }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(e => {
        this.contatto = null
        this.contatti = []
        this.aziende = e.data.map(e => {
          e['label'] = `${e['ragione_sociale']} - ${e['codice_fiscale']}`
          return e
        })
        loading(false)
      })
    },
    fetchContatti(q, loading) {
      if (q.trim().length < 3) {
        this.aziende = []
        this.contatti = []
        return
      }
      loading(true)

      axios.post(process.env.VUE_APP_BACKEND_API+'/contatto/trova_live', { keyword: q }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(e => {
        this.aziende = []
        this.azienda = null
        this.contatti = e.data.map(e => {
          e['label'] = `${e['nome']} ${e['cognome']}`
          return e
        })
        loading(false)
      })
    },
    getUtenti() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/utente/trova', {
        pag: 1,
        keyword: '',
        take: 50
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      })
      .then(e => {
        this.responsabili = e.data.res.map(e => {
          e['label'] = `${e['nome']}`+' '+`${e['cognome']}`
          return e
        })
      }).catch(e => console.log(e))
    },

    eliminaLead(ev) {
      this.$emit('elimina-lead')
      ev.stopPropagation()
    },
    setRating: function(rating){
      this.reputazione= rating
    },
    clearDate(ev) {
      this.data_completamento = ""
      ev.stopPropagation()
    },
    clearDateScad(ev) {
      this.data_scadenza = ""
      ev.stopPropagation()
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
    formatDate(date) {
      let d = new Date(date)
      var options = { year: "numeric", month: "short", day: "numeric" }
      return date ? d.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ') : ''
    },
    fillLeads(val) {
      if (val) {
        this.leads_cliente = val.leads.filter( l => {if (!l.data_completamento && l.stato.nome != 'Non Soddisfatto') return l})
        if (this.id) {
          this.leads_cliente = this.leads_cliente.filter( l => l.id != this.id )
        }
      }
    }
  },
  computed: {
    canEdit: {
      get() {
        return !this.id || +this.utente_id === +this.creatore.id || (this.responsabile && +this.utente_id === +this.responsabile.id) || this.$acl.check('admin')
      },
    }
  },
  watch: {
    radio_ca() {
      this.formkey = Math.random()
    }
  }
}
</script>
